import React, { Component } from 'react'
import './css.css';

class Manifest extends Component {
   
    render(){
        console.log(this.props.update) 
        return ( 
            <div>
                <div id="bows_flyer" className="text white">
                    <div id="bows_mainlabel">🎈 MANIFEST</div>
                    <div id="bows_sublabel">Decentralized Org Phylosophy</div>
                    <div className="bows_panel dark darkblue text white">
                        <div className="instructions_title light lightblue text white">🔒 PRINCIPLES</div>
                        <br></br><br></br>
                        SmartShop is autonomous.
                        <br></br>
                        <br></br>
                        SmartShop is decentralized.
                        <br></br>
                        <br></br>
                        SmartShop is a tokenized Org ruled by Bows tokens.
                        <br></br>
                        <br></br>
                        SmartShop is modular.
                        <br></br>
                        <br></br>
                        Anyone can propose a new module. 
                        <br></br>
                        <br></br>
                        Modules creators have permanent financial rights.
                        <br></br>
                        <br></br>
                        Modules creators can't take advantage of their permanent rights in case of obsolescent modules.
                        <br></br>
                        <br></br>
                        SmartShop promotes a Referrals Economy
                        <br></br>
                        <br></br>
                        SmartShop is fair and has low fees
                        <br></br>
                        <br></br>
                        SmartShop should promote in the long term a fair capillar spread of Bows tokens
                        
                        <br></br><br></br><br></br>
                        <div  className="instructions_title light lightblue">💎 INCOME</div>
                        <br></br><br></br>
                        SmartShop distributes an ideal 20% of all income to a Referrals Economy
                        <br></br>
                        <br></br>
                        Unreferred products will trigger a Referrals Lottery (autonomous, out of SmartShop control)
                        <br></br>
                        <br></br>
                        SmartShop distributes 20% of all income to the Modules Creators whose modules produced the income
                        <br></br>
                        <br></br>
                        1% is distributed to who ideated the module and added it to the ideas list
                        <br></br>
                        <br></br>
                        The remaining 59% is the final SmartShop income
                        <br></br>
                        <br></br>
                        <br></br>
                        <div  className="instructions_title light lightblue">🌹 FINAL SMARTSHOP INCOME</div>
                        <br></br>
                        <br></br>
                        30% of final SmartShop income is ideally distributed to creators via Hackathons
                        <br></br>
                        <br></br>
                        30% of final SmartShop income is ideally used for development of the platform to the next level.
                        <br></br>
                        <br></br>
                        10% of final SmartShop income is ideally used for buying back Bows from the market and operate fair distributions (decided by voting).
                        <br></br>
                        <br></br>
                        SmartShop Bows holders can vote on what to do with the remaining 30% of final SmartShop income. (Prizes, Gifts, Airdrops, Farming or anything else)
                        <br></br><br></br><br></br>
                        
                    </div>
                </div>
            </div>
        );
    }

}

export default Manifest